// import * as React from 'react';
// import * as ReactDOM from 'react-dom';
// import {Dropdown, DropdownProps} from './Dropdown';
// import "./Dropdown.scss";


import { QuestsModel, WorkflowsJourney } from "../../../Models/Quests/Quests.Model";

import { useEffect } from "react";

import { Dropdown, SelectableOption } from "@swivl-mono/ui";
import { JourneyInterface, QuestInterface, Slug } from "@swivl-mono/types";
import { useQuestOptions } from "../../../Hooks/useQuestOptions";



interface Props {
  value?: any;
  name?: string;
  prependOptions?: SelectableOption[];
  stayAtTopOnOpen?: boolean;
  questSelected?(slug: Slug, name?: string): void;
  onChange?(event: { target: { name: string; value: any } });
  optionSelected?(option: SelectableOption, name?: string): void;
  disableEditing?: boolean;
  filterJourney?(journey: JourneyInterface): boolean;
  filterQuest?(quest: QuestInterface): boolean;
}



export function QuestOptions(
  workflows: WorkflowsJourney[],
  prependOptions?: SelectableOption[],
  filterJourney?: (journey: JourneyInterface) => boolean,
  filterQuest?: (quest: QuestInterface) => boolean
): SelectableOption[] {

  let questOptions: SelectableOption[] = [];


  if (workflows) {
    for (var i = 0; i < workflows.length; i++) {
      if (workflows[i].quests.length == 0) continue;
      if (filterJourney && !filterJourney(workflows[i]!.journey!)) continue;

      const journeyQuests: SelectableOption[] = [];

      for (var q = 0; q < workflows[i].quests.length; q++) {
        const quest = workflows[i].quests[q];
        if (filterQuest && !filterQuest(quest)) continue;
        journeyQuests.push({ value: quest.slug, label: quest?.name });
      }

      if (journeyQuests.length > 0) {
        questOptions.push({ isHeading: true, label: workflows[i].journey?.name || "Unassigned" });
        questOptions.push(...journeyQuests);
      }
    }
  }
  questOptions = prependOptions ? prependOptions.concat(questOptions) : questOptions;
  return questOptions;
}


export function QuestsDropdown(props: Props) {
  const { value, prependOptions, name, stayAtTopOnOpen, questSelected, onChange, optionSelected, disableEditing } =
    props;

  // const {  workflows } = QuestsModel.useState((s) => s);
  // useEffect(() => {
  //   QuestsModel.loadQuestsList(false);
  // }, []);
  const questOptions = useQuestOptions(prependOptions, props.filterJourney, props.filterQuest);

  const optionSelectedMethod = (option: SelectableOption) => {
    if (optionSelected) {
      optionSelected(option, name);
    }
    if (questSelected) {
      questSelected(option.value, name);
    }
  };

  return (
    <Dropdown
      options={questOptions}
      value={value}
      name={name}
      optionSelected={optionSelectedMethod}
      showSearch={true}
      stayAtTopOnOpen={stayAtTopOnOpen}
      onChange={onChange}
      disableEditing={disableEditing}
    />
  );
}
